import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  Input,
  ViewChildren,
  QueryList,
} from '@angular/core';
import { FiltroControllerService } from 'src/app/services/filtro-controller.service';
import { CommonModule } from '@angular/common';
import { ModulosDeFormulario } from 'src/app/utils/formsModules';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRadioModule } from '@angular/material/radio';
import { MatMenuModule, MatMenuTrigger } from '@angular/material/menu';
import { UsuariosComponent } from '../../sub-filtros/usuarios/usuarios.component';
import { registerCloseOtherMenus } from '../../filtro-utils';
import { RamosComponent } from '../../sub-filtros/ramos/ramos.component';
import { Subscription } from 'rxjs';
import { FiltroCotacoesRamoService } from '../../filtros/cotacoes-ramo/filtro-cotacoes-ramo.service';
import { IntegracaoConstants } from 'src/app/constants/integracao';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { heroClockMicro } from '@ng-icons/heroicons/micro';
import { heroChevronLeftMini } from '@ng-icons/heroicons/mini';
import {
  heroMapPinSolid,
  heroUserGroupSolid,
  heroCalculatorSolid,
} from '@ng-icons/heroicons/solid';

@Component({
  selector: 'filtro-negocios',
  templateUrl: './negocios.component.html',
  styleUrls: ['../../filtro.component.scss'],
  providers: [
    provideIcons({
      heroClockMicro,
      heroChevronLeftMini,
      heroMapPinSolid,
      heroUserGroupSolid,
      heroCalculatorSolid,
    }),
  ],
  imports: [
    CommonModule,
    ModulosDeFormulario,
    MatTooltipModule,
    MatCheckboxModule,
    MatRadioModule,
    MatMenuModule,
    UsuariosComponent,
    RamosComponent,
    NgIcon,
  ],
})
export class NegociosComponent implements OnInit {
  @Output('eventFilter') eventFilter = new EventEmitter();
  @Output('clearFilter') limpaFiltro = new EventEmitter();
  @Input('listaUsuarios') listaUsuarios: any = {};
  @ViewChildren(MatMenuTrigger) allTriggers!: QueryList<MatMenuTrigger>;

  filtroRamo: { ramo: string; subRamos: string[] }[] = [];
  filtroUsuario = [];

  protected ramosTabs = IntegracaoConstants.ramosTabs;

  protected currentTab = this.ramosTabs[0];

  private tabSubscription!: Subscription;
  private clearSubscription!: Subscription;

  constructor(
    public filtroController: FiltroControllerService,
    private filtroCotacoesRamoService: FiltroCotacoesRamoService
  ) {}

  ngOnInit() {
    this.inicializaFiltros();

    this.tabSubscription = this.filtroCotacoesRamoService.currentTab$.subscribe(
      (tab) => {
        this.currentTab = this.ramosTabs.find((x) => x.id == tab);
      }
    );

    this.clearSubscription = this.filtroCotacoesRamoService.clear$.subscribe(
      () => {
        this.clearFilter();
      }
    );
  }

  ngAfterViewInit() {
    registerCloseOtherMenus(this.allTriggers);
  }

  ngOnDestroy() {
    this.tabSubscription.unsubscribe();
    this.clearSubscription.unsubscribe();
  }

  inicializaFiltros() {
    if (this.filtroController.filtroNegocio) {
      this.filtroUsuario = this.filtroController.filtroNegocio.usuario;

      this.filtroRamo = this.filtroController.filtroNegocio.listaRamo;
    }
  }

  buildString() {
    this.filtroController.addFiltrosExtras('negocios', {
      listaRamo: this.filtroRamo,
      usuario: this.filtroUsuario,
    });

    let rawValue = {
      usuario: this.filtroController.filtroNegocio.usuario,
      listaRamo: this.filtroController.filtroNegocio.listaRamo,
    };

    let filtros = { values: rawValue };

    this.filtroController.verificaFiltro();

    this.eventFilter.emit(filtros);

    return filtros;
  }

  clearFilter() {
    this.filtroUsuario = [];
    this.filtroRamo = [];
    this.filtroController.limparFiltro('negocios');
    this.filtroCotacoesRamoService.clearFilters();
    this.filtroController.verificaFiltro();
    this.buildString();
  }

  getRamosCount() {
    const ramoFilter = this.filtroController.getActiveFilter('ramos');

    return ramoFilter ?? 0;
  }

  getUsersCount() {
    const userFilter = this.filtroController.getActiveFilter('users');

    return userFilter ?? 0;
  }
}
